import './StatsValueContainer.scss';

export type StatsValueContainerProps = {
  title: string;
  value: number;
  unit: string;
  showRibbon?: boolean;
  color?: 'red' | 'green' | 'blue';
};

export const StatsValueContainer: React.FC<StatsValueContainerProps> = ({
  title,
  value,
  unit,
  showRibbon,
  color,
}) => {
  return (
    <div className="d-flex stats-value-container align-items-center my-2">
      <span className="title flex-grow-1">{title}</span>
      {showRibbon ? (
        <div className="d-flex align-items-center ribbon-content">
          <div className={`ribbon ${color || ''}`}>
            <span>
              {value} {unit}
            </span>
          </div>
        </div>
      ) : (
        <span className="stats-value">
          {value} {unit}
        </span>
      )}
    </div>
  );
};
